// Generated by IcedCoffeeScript 1.7.1-c
(function() {
  exports.Generator = require('../lib/generator').Generator;

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./~/more-entropy/lib/main.js
// module id = 675
// module chunks = 0